import React, { FC, SyntheticEvent, useCallback } from 'react';
import { Grid, Link } from '@material-ui/core';
import { useHistory } from 'react-router';
import { useStyles } from './styles';
import { PATH_NOTIFICATIONS } from '../../../utils';
import { NotificationIcon } from '../../CustomIcons';

interface Props {
  notification: any;
  translation: any;
  closeMenu: () => void;
}

export const NotificationMenuItem: FC<Props> = ({ notification, translation, closeMenu }) => {
  const classes = useStyles();
  const history = useHistory();

  const redirectToNotificationsPage = useCallback(
    (event: SyntheticEvent) => {
      event.preventDefault();
      closeMenu();
      history.push(PATH_NOTIFICATIONS, [notification.notification]);
    },
    [history, notification, closeMenu],
  );

  return (
    <Grid container direction="row" justify="space-between" alignItems="center" className={classes.card}>
      <Grid item xs={12}>
        <Link href="" underline="none" onClick={redirectToNotificationsPage}>
          <Grid container direction="row" alignItems="flex-end">
            <NotificationIcon />
            <Grid item xs={9} className={classes.message}>
              <Grid item className={classes.title}>
                {notification.type === 'ClientAssignedUnderPartnership'
                  ? translation.new_client_assigned
                  : notification.type === '12'
                  ? `${translation.cashback_campaign} ${notification.payload.Name} ${translation.deactivated_due_to_end_date}`
                  : notification.message}
              </Grid>
              <Grid item className={classes.time}>
                {notification.receivedTime}
              </Grid>
              {!notification.isRead && (
                <Grid item className={classes.status}>
                  {translation.text_15}
                </Grid>
              )}
            </Grid>
          </Grid>
        </Link>
      </Grid>
    </Grid>
  );
};
